module.exports = __webpack_public_path__ + "media/images/logo/logo-90a585172d1a4004500d37cbc3a2c7c1.svg";